import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useProductDetailsMassActionBarStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 44,
    paddingLeft: theme.spacing(0.75),
    paddingRight: theme.spacing(1.5),
    backgroundColor: theme.palette.accent.dark,
    borderRadius: theme.shape.borderRadiusLg,
    boxShadow: `0px 2px 4px ${alpha(theme.palette.common.black, 0.1)}`,
  },
  pasteToAllButton: {
    border: 'none',
    fontSize: theme.typography.body2.fontSize,
  },
}));
